import React from 'react';
import Navbar from '../core/components/Navbar/Navbar';
import Footer from '../core/components/Footer/Footer';
import CSSLoader from './CSSLoader';

const CoreLayout = ({ children, userLogout }) => {

  return (
    <div className="core-app" id="core-app">
      <CSSLoader />
      <Navbar userLogout={userLogout} />
      <div className="core">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default CoreLayout;